export default "__VITE_ASSET__CveW7kak__"